import { useEffect, useState } from "react";
import { Translate } from "../../translate";
import { getStore } from "../../utils/global";
import PreviewRoot from "../PreviewRoot";

export default function Step3({ data }) {
  const user = getStore("user");
  const [page, setPage] = useState(1);

  let { file, parts, stamps } = data;
  let ln = typeof getStore("lang") === "object" ? "en" : getStore("lang");

  const make_box = (per) => {
    let box = document.createElement("div");
    let inside = document.createElement("div");
    box.style.height = per.height + "px";
    box.style.width = per.width + "px";
    box.style.background = per.color;
    box.style.border = "1px solid " + per.color;
    box.style.left = per.x1 + "px";
    box.style.bottom = per.y1 + "px";
    box.style.position = "absolute";
    box.className = "drop_box";
    inside.className = "drop_box_name";
    inside.style.width = per.boxwidth + "px";
    inside.style.overflowWrap = "break-word";
    if (per?.type?.includes("Text")) {
      box.style.textAlign = "left";
      box.style.alignItems = "start";
    }

    if (["yourStamp", "yourSignature", "yourInitials"].includes(per.unique_key)) {
      inside.innerHTML = per.shortname;
    } else inside.innerHTML = `${per.value ? per.value : per.url ? `<div class="yourSignature">${per.drag_txt}</div>` : per.drag_txt}`;

    if (per.url) {
      box.style.backgroundColor = "#ffffff";
      box.style.backgroundImage = "url('" + per.url + "')";
      box.style.backgroundRepeat = "no-repeat";
      box.style.backgroundSize = "contain";
      box.style.backgroundPositionX = "right";
    }
    box.appendChild(inside);
    if (per.unique_key === "signature") {
      let inside_name = document.createElement("div");
      inside_name.className = "drop_box_sign";
      inside_name.innerHTML = per.username;
      box.appendChild(inside_name);
    }
    return page === per.page ? box : null;
  };

  const renderTools = () => {
    let container = document.querySelector(".document_watermark_container");
    if (!container) return;
    let droppable = document.createElement("div");
    droppable.className = "document_watermark_container_dropable";
    container.innerHTML = "";
    container.appendChild(droppable);

    stamps?.forEach((per) => {
      if (page === per.page) {
        let box = make_box(per);
        container.appendChild(box);
      }
    });
  };

  useEffect(() => {
    renderTools();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  return (
    <div className="step1_container relafull">
      <div className="step1_detail">
        <div className="step1_user_detail" style={{ marginTop: 20 }}>
          <div className="step1_user_detail_title">{Translate[ln].NewDoc.Preview.Sender} </div>
          <div className="step1_user_detail_body">
            <div className="user_dropdown_name">{user.kdss_name}</div>
            <div className="user_dropdown_mobile">{user.kdss_msisdn}</div>
            <div className="user_dropdown_email" color="1">
              {user.kdss_email}
            </div>
          </div>
        </div>
        <div className="parts_scroll_area">
          {parts.map((per, i) => {
            return (
              <div key={i} className="step1_user_detail" style={{ marginTop: 20 }}>
                <div
                  className="step1_user_detail_title"
                  style={{
                    background: per.bg_color,
                    textTransform: "capitalize",
                  }}>
                  {Translate[ln].NewDoc.Preview[per?.actionrole]}
                </div>
                <div className="step1_user_detail_body">
                  <div className="user_dropdown_name">{per.name}</div>
                  <div className="user_dropdown_mobile">{per.msisdn}</div>
                  <div className="user_dropdown_email" color="1">
                    {per.email}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className="step3_body">
        <div className="absfull">
          <PreviewRoot
            file={file}
            pageChange={setPage}
            stamps={[]}
            onSuccess={() => {
              let element = document.createElement("div");
              let dropable = document.createElement("div");
              dropable.className = "document_watermark_container_dropable";
              element.className = "document_watermark_container";
              element.appendChild(dropable);
              document.querySelector(".react-pdf__Page").appendChild(element);
              renderTools();
            }}
          />
        </div>
      </div>
    </div>
  );
}
